export const CATEGORY_6_TO_12_MONTHS = '6 to 12 Months';
export const CATEGORY_12_PLUS_MONTHS = '12+ Months';
export const CATEGORY_ALL = 'All';
export const IRON_RICH_RECIPES = 'Iron Rich Recipes';